<template>
    <transition name="fade">
        <div class="Viewer3D" v-show="viewer3DVisible"> <!-- @click="toggleViewer3D()" -->
            <div class="v3-container"> <!-- @click="$event.stopPropagation()" -->
                
                <!-- Toolbar -->
                <div class="v3-bar">
                    <transition name="fade">
                        <p class="v3-bar-name">{{title}}</p>
                    </transition>
                    <div class="v3-bar-buttons">  
                        <md-button class="md-icon-button" @click="toggleViewer3D()" style="margin-right: 0;">
                            <CloseIcon class="closeIcon"/>
                        </md-button>
                    </div> 
                </div>

                <!-- Loadingscreen -->
                <div id="v3-loadingScreen" class="v3-loadingscreen">
                    <div>
                        <img class="v3-logo" :src="publicPath+'/media/'+logoURL" alt="">
                        <div class="v3-text" id="v3-text">0%</div>
                        <svg class="v3-animation" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                            <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                <animateTransform attributeName="transform" attributeType="XML"  type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
                            </path>
                        </svg>
                    </div>
                </div>

                <!-- Canvas -->
                <Canvas id="v3-canvas" class="v3-canvas"/>  

            </div>         

        </div>  
    </transition>
</template>

<style scoped>
    .Viewer3D{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
        z-index: 5;
    }
    .v3-container{
        position: absolute;
        background: white;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
        overflow: hidden;
        width: 88%;
        height: 88%;
    }
    .v3-bar{
        padding: 3px;
        padding-right: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.774);
        display: flex;
        position: relative;
    }
    .v3-bar-name{
        width: 100%;
        text-align: center;
        font-size: 18px;
        margin: auto 0;
    }
    .v3-bar-buttons{
        margin-left: auto;
    }
    .v3-canvas{
        width: 100%;
        height: calc(100% - 46px);
        outline: none;
    }
    .material-design-icon {
        height: 2.4em;
        width: 2.4em;
    }
    .material-design-icon > .material-design-icon__svg {
        fill: black;
        height: 2.4em;
        width: 2.4em;
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
    }
    .material-design-icon.closeIcon {
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.closeIcon> .material-design-icon__svg {
        fill: rgb(252, 113, 113);
        height: 2.5em;
        width: 2.5em;
    }
    .v3-loadingscreen{
        pointer-events: none;
        opacity: 0;
        transition: 1s opacity ease-in-out;
        position: absolute;
        width: 100%;
        height: calc(100% - 46px);
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .v3-logo{
        width: 350px;
    }
    .v3-animation{
        fill: var(--primaryColor);
        width: 200px;
        height: 200px;
        margin: auto;
        display: block;
    }
    .v3-text{
        font-size: 24px;
        margin-top: 20px;
        color: var(--primaryColor);
        text-align: center;
        font-weight: bolder;
    }
</style>
    
<script>
import {mapGetters,mapMutations} from 'vuex';
import * as BABYLON from 'babylonjs';
import 'babylonjs-loaders';
import MediaManager from "@/api/MediaManager";

// Icons
import CloseIcon from 'vue-material-design-icons/Close.vue'
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'

export default {
    components: {CloseIcon,OpenInNewIcon},
    data: function () {
        this.engine = null,
        this.scene = null,
        this.loadedMeshes = [] // Aray with urls to meshes

        return{
            viewer3DVisible: false, 
            meshURL: null,
            title: "",
            publicPath: process.env.BASE_URL,
        }
    }, 
    computed: {
        ...mapGetters(['logoURL','allPrefabs','currentSituationID'])
    },
	methods: {
        ...mapMutations(["setDialogueOpen"]),
        toggleViewer3D(){
            this.viewer3DVisible = !this.viewer3DVisible;
            this.setDialogueOpen(this.viewer3DVisible);
            this.viewer3DVisible ? this.showViewer() : this.hideViewer();
        },
        showViewer(){
            if(this.loadedMeshes.find(mesh => mesh == this.meshURL)){
                this.scene.getMeshByName(this.meshURL).setEnabled(true);
                this.configureCamera();
                this.configureDome();

                this.engine.runRenderLoop(()=> { this.scene.render(); });
            }else{
                this.engine.displayLoadingUI();

                // Load new Model
                BABYLON.SceneLoader.ImportMesh("","", this.meshURL, this.scene, (meshes) =>{ // onSuccess
                    meshes[0].name = this.meshURL;
                    this.loadedMeshes.push(this.meshURL);

                    // Configure Camera
                    this.configureCamera();

                    // Set Skydome Texture
                    this.configureDome();
                    
                    this.engine.hideLoadingUI();
                    this.engine.runRenderLoop(()=> { this.scene.render(); });

                },(evt) => { // onProgress
                    var loadedPercent = 0;
                    if(evt.lengthComputable){
                        loadedPercent = (evt.loaded * 100 / evt.total).toFixed();
                    }else{
                        var dlCount = evt.loaded / (1024 * 1024);
                        loadedPercent = Math.floor(dlCount * 100.0) / 100.0;
                    }
                    document.getElementById("v3-text").innerHTML = loadedPercent + "%";
                });
            }
        },
        configureDome(){
            console.log("Changing Dome Texture")
            let dome = this.scene.getNodeByName("V3-Dome");
            let prefab = this.allPrefabs.find(prefab => prefab.id == this.currentSituationID && prefab.type == "RoomImage");
            dome.photoTexture.dispose();
            dome.photoTexture = new BABYLON.Texture(MediaManager.getMedia(prefab.getSphereImageID()).url,this.scene);
            dome.setEnabled(true);
        },
        configureCamera(){
            if(this.scene.activeCamera)
                this.scene.activeCamera.dispose();
            this.scene.createDefaultCamera(true,true,true);
            let camera =  this.scene.activeCamera;
            camera.alpha = 1;
            camera.beta = 1;
            camera.lowerRadiusLimit = camera.radius * 0.3;
            camera.radius *= 0.9;
            camera.upperRadiusLimit = camera.radius * 1.7;
            camera.inputs.attached.pointers.buttons = [0,1];
        },
        hideViewer(){
            this.scene.getNodeByName("V3-Dome").setEnabled(false);
            this.scene.getMeshByName(this.meshURL).setEnabled(false);
            this.engine.stopRenderLoop();
        },
        init3DViewer(){
            const canvas = document.getElementById("v3-canvas");
            this.engine = new BABYLON.Engine(canvas, true, { stencil: true, xrCompatible: false });
            this.engine.setHardwareScalingLevel(1 / window.devicePixelRatio);
            this.engine.enableOfflineSupport = true;
            BABYLON.Database.IDBStorageEnabled = true;
            BABYLON.Engine.OfflineProviderFactory = (urlToScene, callbackManifestChecked, disableManifestCheck) => {
                return new BABYLON.Database(urlToScene, callbackManifestChecked, true);
            };

            function customLoadingScreen() {}
            customLoadingScreen.prototype.displayLoadingUI = function () {
                document.getElementById("v3-loadingScreen").style.opacity = 1;
            };
            customLoadingScreen.prototype.hideLoadingUI = function () {
                document.getElementById("v3-loadingScreen").style.opacity = 0;
            };
            this.engine.loadingScreen = new customLoadingScreen();

            this.scene = new BABYLON.Scene(this.engine);
            this.scene.clearColor = new BABYLON.Color3(1,1,1);
            this.scene.environmentTexture = new BABYLON.CubeTexture("https://assets.babylonjs.com/environments/environmentSpecular.env", this.scene); 
             this.scene.debugLayer.show();

            let light = new BABYLON.HemisphericLight("HemiLight", new BABYLON.Vector3(0, 1, 0), this.scene);
            light.intensity = 0.5;

            let dome = new BABYLON.PhotoDome("V3-Dome","", { resolution: 32, faceForward: false, size: 1000}, this.scene);
            dome.mesh.material.alpha = 0.2;
            dome.scaling.y *= -1;
            dome.setEnabled(false);

            const resizeObserver = new ResizeObserver(() => {setTimeout(() => {this.engine.resize(); }, 0); });
            resizeObserver.observe(canvas);
        }
    },
    mounted(){
        this.init3DViewer();
        window.addEventListener('openViewer3D',(e) => {
            this.meshURL = e.detail.meshURL;
            this.title = e.detail.name;
            this.toggleViewer3D();
        });

        
    },
    destroyed(){
        console.log("destroyed");
        this.engine.dispose();
    }
}

</script>